import { IDocumentImageSource } from "../../../domain/document";

export class ProRadDrawExecuteResult {
  isComplete: boolean;
  images: ProRadDrawImageResult[];
}

export class ProRadDrawImageResult {
  sourceGuid: string;
  imageSource: IDocumentImageSource;
}
